/**
 * Provides background color configuration for the main layout components:
 * body, header, and footer. Allows different background styles for specific
 * routes (pages), using theme tokens and gradients where appropriate.
 *
 * Usage:
 *   - Maps pathname patterns to color settings for child regions and layout elements.
 *   - Supports exact and prefix-based pathname color mapping.
 *
 * Example:
 *   getBgColorForPath("/trade") returns config for Trade page backgrounds.
 */

import { token } from "styled-system/tokens";

export type HeaderBackgroundConfig = { mobile?: string; desktop?: string } | string;

interface BackgroundConfig {
  children?: string;
  header?: HeaderBackgroundConfig;
  footer?: string;
}

export const bgColors: Record<string, BackgroundConfig> = {
  "/points": {
    children: `linear-gradient(218deg, ${token("colors.dark.500")} 5.09%, ${token("colors.dark.700")} 94.58%)`,
    footer: "transparent",
    header: "transparent",
  },
  "/card-vault": {
    children: "#000000",
    footer: "transparent",
    header: "transparent",
  },
};

export function getBackgroundForPath(pathname: string): BackgroundConfig | undefined {
  // Check exact match first
  if (bgColors[pathname]) {
    return bgColors[pathname];
  }

  // Check if pathname starts with any key
  for (const [path, color] of Object.entries(bgColors)) {
    if (pathname.startsWith(path)) {
      return color;
    }
  }

  return undefined;
}
